export default "__VITE_ASSET__DRorrnAx__"